module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.localShipment.id) ? _c('div', {
    staticClass: "padding-sm-all padding-lg-bottom"
  }, [_c('el-form', {
    ref: "create-shipment-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localShipment,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin border-bottom",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h2', {
    staticClass: "shipment-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Thông tin người nhận")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "receiver.name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localShipment.receiver.name),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.receiver, "name", $$v)
      },
      expression: "localShipment.receiver.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Điện thoại",
      "prop": "receiver.phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Điện thoại"
    },
    model: {
      value: (_vm.localShipment.receiver.phone),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.receiver, "phone", $$v)
      },
      expression: "localShipment.receiver.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Địa chỉ đến",
      "prop": "address_to.street"
    }
  }, [_c('el-input', {
    attrs: {
      "name": "address_to.street",
      "placeholder": "Địa chỉ đến"
    },
    model: {
      value: (_vm.localShipment.address_to.street),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "street", $$v)
      },
      expression: "localShipment.address_to.street"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tỉnh thành",
      "prop": "address_to.city_code"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn tỉnh thành đến"
    },
    on: {
      "change": function($event) {
        return _vm.getDistrictTo(false)
      }
    },
    model: {
      value: (_vm.localShipment.address_to.city_code),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "city_code", $$v)
      },
      expression: "localShipment.address_to.city_code"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quận huyện",
      "prop": "address_to.district_code"
    }
  }, [_c('el-col', {
    staticClass: "margin-sm-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "disabled": _vm.localShipment.address_to && !_vm.localShipment.address_to.city_code,
      "filterable": "",
      "placeholder": "Chọn quận huyện đến"
    },
    on: {
      "change": function($event) {
        return _vm.changeDistrictTo(false)
      }
    },
    model: {
      value: (_vm.localShipment.address_to.district_code),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "district_code", $$v)
      },
      expression: "localShipment.address_to.district_code"
    }
  }, _vm._l((_vm.districtTo), function(district) {
    return _c('el-option', {
      key: district.id,
      attrs: {
        "label": district.name,
        "value": district.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phường xã",
      "prop": "address_to.ward_id"
    }
  }, [_c('el-col', {
    staticClass: "margin-sm-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "disabled": _vm.localShipment.address_to && !_vm.localShipment.address_to.district_code,
      "filterable": "",
      "placeholder": "Phường xã đến"
    },
    model: {
      value: (_vm.localShipment.address_to.ward_id),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.address_to, "ward_id", $$v)
      },
      expression: "localShipment.address_to.ward_id"
    }
  }, _vm._l((_vm.wardTo), function(ward) {
    return _c('el-option', {
      key: ward.id,
      attrs: {
        "label": ward.name,
        "value": ward.id.toString()
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h2', {
    staticClass: "shipment-block"
  }, [_c('i', {
    staticClass: "fa fa fa-info-circle"
  }), _vm._v(" Thông tin hàng gửi")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tiền thu hộ (COD)",
      "prop": "parcel.cod_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiền thu hộ (COD)"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('parcel.cod_amount')
      },
      "blur": function($event) {
        return _vm.addZero('parcel.cod_amount')
      }
    },
    model: {
      value: (_vm.localShipment.parcel.cod_amount),
      callback: function($$v) {
        _vm.$set(_vm.localShipment.parcel, "cod_amount", $$v)
      },
      expression: "localShipment.parcel.cod_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.parcel.cod_amount)))])])], 2)], 1), _vm._v(" "), (_vm.showUpdateToCarrier) ? _c('el-form-item', {
    attrs: {
      "label": "Cập nhật tiền thu hộ (COD) sang hãng",
      "prop": "update_to_carrier"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.update_to_carrier),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "update_to_carrier", $$v)
      },
      expression: "localShipment.update_to_carrier"
    }
  }, [_vm._v(" Cập nhật tiền thu hộ (COD) sang hãng ")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phí vượt cân",
      "prop": "over_weight_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí vượt cân"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('over_weight_fee')
      },
      "blur": function($event) {
        return _vm.addZero('over_weight_fee')
      }
    },
    model: {
      value: (_vm.localShipment.over_weight_fee),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "over_weight_fee", $$v)
      },
      expression: "localShipment.over_weight_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.over_weight_fee)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phí giao lại",
      "prop": "re_delivery_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí giao lại"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('re_delivery_fee')
      },
      "blur": function($event) {
        return _vm.addZero('re_delivery_fee')
      }
    },
    model: {
      value: (_vm.localShipment.re_delivery_fee),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "re_delivery_fee", $$v)
      },
      expression: "localShipment.re_delivery_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.re_delivery_fee)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phí khác",
      "prop": "update_info_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí cập nhật"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('update_info_fee')
      },
      "blur": function($event) {
        return _vm.addZero('update_info_fee')
      }
    },
    model: {
      value: (_vm.localShipment.update_info_fee),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "update_info_fee", $$v)
      },
      expression: "localShipment.update_info_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localShipment.update_info_fee)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Người thanh toán"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isCoin
    },
    model: {
      value: (_vm.localShipment.payer),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "payer", $$v)
      },
      expression: "localShipment.payer"
    }
  }, _vm._l((_vm.shipmentHelpers.payers), function(payer, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(payer))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ghi chú cập nhật",
      "prop": "note_update"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Ghi chú cập nhật"
    },
    model: {
      value: (_vm.localShipment.note_update),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "note_update", $$v)
      },
      expression: "localShipment.note_update"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tình trạng đơn hàng"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.part_delivery || !!_vm.localShipment.is_lost || !!_vm.localShipment.is_error,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.is_return),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "is_return", $$v)
      },
      expression: "localShipment.is_return"
    }
  }, [_vm._v(" Chuyển hoàn ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.is_return || !!_vm.localShipment.is_lost || !!_vm.localShipment.is_error,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.part_delivery),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "part_delivery", $$v)
      },
      expression: "localShipment.part_delivery"
    }
  }, [_vm._v(" Giao một phần ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.is_return || !!_vm.localShipment.part_delivery || !!_vm.localShipment.is_error,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.is_lost),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "is_lost", $$v)
      },
      expression: "localShipment.is_lost"
    }
  }, [_vm._v(" Thất lạc hàng ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": !!_vm.localShipment.is_return || !!_vm.localShipment.part_delivery || !!_vm.localShipment.is_lost,
      "false-label": 0,
      "true-label": 1
    },
    model: {
      value: (_vm.localShipment.is_error),
      callback: function($$v) {
        _vm.$set(_vm.localShipment, "is_error", $$v)
      },
      expression: "localShipment.is_error"
    }
  }, [_vm._v(" Đơn gửi sang hãng lỗi ")])], 1)], 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5575974c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compare/UpgradeShipment.vue
// module id = 643
// module chunks = 1